export default {
  namespaced: true,
  state: {
    auditStateEnum: [
      {label: '待审核', value: 1},
      {label: '已通过', value: 3},
      {label: '已拒绝', value: 2},
    ],
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/userstate/index.js